package com.cs.ejobin.vm

import com.cs.ejobin.data.AuthRepository
import com.cs.ejobin.i18n.Keys
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class ForgotPasswordState(
    val email: String = "",
    val newPassword: String = "",
    val confirmPassword: String = "",
    val isLoading: Boolean = false,
    val errorKey: String? = null
)

class ForgotPasswordViewModel(
    private val auth: AuthRepository
) : BaseViewModel() {

    private val _state = MutableStateFlow(ForgotPasswordState())
    val state: StateFlow<ForgotPasswordState> = _state.asStateFlow()

    fun onEmail(v: String) { _state.value = _state.value.copy(email = v, errorKey = null) }
    fun onNewPassword(v: String) { _state.value = _state.value.copy(newPassword = v, errorKey = null) }
    fun onConfirmPassword(v: String) { _state.value = _state.value.copy(confirmPassword = v, errorKey = null) }

    fun clearError() {
        _state.value = _state.value.copy(errorKey = null)
    }

    fun sendResetEmail(onNext: () -> Unit) {
        val s = _state.value
        val email = s.email.trim()
        if (email.isEmpty()) {
            _state.value = s.copy(errorKey = Keys.required_email, isLoading = false)
            return
        }

        _state.value = s.copy(isLoading = true, errorKey = null)

        scope.launch {
            runCatching { auth.requestPasswordReset(email) }
                .onSuccess {
                    _state.value = _state.value.copy(isLoading = false)
                    onNext()
                }
                .onFailure {
                    _state.value = _state.value.copy(isLoading = false, errorKey = Keys.error_generic)
                }
        }
    }

    fun updatePassword(onSuccess: () -> Unit) {
        val s = _state.value

        if (s.newPassword.length < 6) {
            _state.value = s.copy(errorKey = Keys.weak_password, isLoading = false)
            return
        }
        if (s.newPassword != s.confirmPassword) {
            _state.value = s.copy(errorKey = Keys.password_mismatch, isLoading = false)
            return
        }

        _state.value = s.copy(isLoading = true, errorKey = null)

        scope.launch {
            runCatching { auth.updatePassword(s.newPassword) }
                .onSuccess {
                    _state.value = _state.value.copy(isLoading = false)
                    onSuccess()
                }
                .onFailure {
                    _state.value = _state.value.copy(isLoading = false, errorKey = Keys.error_generic)
                }
        }
    }
}